import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import Swal from 'sweetalert2';
import {

  MenuItem
} from '@mui/material';
import PropTypes from 'prop-types';
const Locationtable = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});
  useEffect(() => {
        setPermission(FindModuleById(221)); 
console.log(permission);

 
      axios.post("/locations/listing",{},{  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
       
        if (response.data.code === 200) {
          setData(response.data.data.locations);
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


const editItem = (item)=>{
  window.location.href = "/locations-edit/"+item;
}




  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/locations/delete/${item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/locations";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
    });
  }
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  const FarmNameCell = ({ row }) => {
    return (
      <a href={`/locations-view/${row.original.id}`} className="">
        {row.original.title}
      </a>
    );
  };
  
  // ✅ Add PropTypes validation
  FarmNameCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        title: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };
const columns =
 [
  {
    header: 'Location Name',
    accessorFn: (row) => `${row.title}`,
    Cell: FarmNameCell,
  },
 
    {
      accessorKey: 'gps_location', //normal accessorKey
      header: 'GPS Location',
    },
    {
      accessorKey: 'numero_de_station', //normal accessorKey
      header: 'Numero De Station',
    },
    {
      accessorKey: 'description', //normal accessorKey
      header: 'Description',
    },
    {
      header: 'Created By',
      accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
    },
    {
      header: 'Updated By',
      accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
    },
  ];

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Processing Lines</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Processing Lines</li>
                </ul>
              </div>
              <div className="col-auto">
              {permission && permission.add == 1 && (
                  <Link to="/locations-add" className="btn btn-primary me-1">
                  <i className="fas fa-plus"></i>
                </Link>
                )} 
                
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
                {permission && permission.list == 1 && (
                  <div className="card card-table">
                    <div className="card-body">
                      <div className="table-responsive">
                      <MaterialReactTable columns={columns} data={data} 
                        // enableColumnFilterModes
                        enableColumnOrdering
                        // enableGrouping
                        enablePinning
                        enableRowActions
                        // enableRowSelection
                        // initialState={{ showColumnFilters: true }}
                        // enableRowActions
                            renderRowActionMenuItems={({ row }) => [
                              permission?.update == 1 && (
                                <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                  Edit
                                </MenuItem>
                              ),
                              permission?.delete == 1 && (
                                <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                  Delete
                                </MenuItem>
                              ),
                            ]}
                       
                      />
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Locationtable;
